module.exports = __webpack_public_path__ + "static/food_wys_guilinggao_happyb74d4b3.wav";